import {cva} from 'class-variance-authority';

const checkListRootVariants = cva(
  'check-list-root m-0 flex w-full list-none flex-col p-0',
  {
    variants: {
      size: {
        default: 'gap-4',
        minimal: 'gap-2',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

const listItemBase =
  'flex items-start gap-2 text-base [&_.check-list-icon]:h-6 [&_.check-list-icon]:w-6';

const listItemMinimalOverrides =
  '[.check-list-root[data-size=minimal]_&]:gap-1.5 [.check-list-root[data-size=minimal]_&]:text-sm [.check-list-root[data-size=minimal]_&_.check-list-icon]:mt-0.5 [.check-list-root[data-size=minimal]_&_.check-list-icon]:h-[15px] [.check-list-root[data-size=minimal]_&_.check-list-icon]:w-[15px]';

const checkListItemVariants = cva(`${listItemBase} ${listItemMinimalOverrides}`);

export {checkListItemVariants, checkListRootVariants};
